import './index.erb';
import './index.rb';
import './index.scss';

(function ($) {
  document.addEventListener('turbolinks:load', function () {
    $('#intervention-collapse-button').on('click', function () {
      const interventionBottomBar = $('#qc-intervention-bottom-bar');
      const collapseData = $(this).data('collapse');

      $(this).data('collapse', !collapseData);

      if (interventionBottomBar.hasClass('collapsed')) {
        interventionBottomBar.removeClass('collapsed');
        $(this).find('span').text('Mostrar mais');
      } else {
        interventionBottomBar.addClass('collapsed');
        $(this).find('span').text('Mostrar menos');
      }
    });
  });
})(jQuery);
